import React from "react";
import ReactDOM from "react-dom/client";
import "@/styles/index.css";
import App from "./App";
import { initSentry, SentryErrorBoundary } from "@/lib/sentry";

// Init Sentry before the React tree mounts so init-time errors are captured.
// No-op when VITE_SENTRY_DSN is empty (local dev / unconfigured deploys).
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center",
          justifyContent: "center", padding: 24, background: "#FFFFFF",
          color: "#1A1A1A", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
        }}>
          <div style={{ maxWidth: 420, textAlign: "center" }}>
            <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 26, marginBottom: 12 }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: 14, color: "#6B7178", marginBottom: 18 }}>
              We've been notified and will look into it. Try reloading the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "#2D5A3D", color: "#fff", border: 0, padding: "10px 18px",
                borderRadius: 8, fontWeight: 600, cursor: "pointer",
              }}
            >
              Reload
            </button>
          </div>
        </div>
      }
    >
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
